import React, {Fragment, useEffect, useState} from 'react';
import { Box, Grid, Stack } from '@mui/material';
import { Outlet, useNavigate } from 'react-router-dom';
import { Header } from '../navigation';
import { Header as MobileHeader, UserDetail } from 'common/components';
import { Footer } from 'common/components/footer';
import { RedTheme } from 'common/global';
import { useScreen } from 'common/hooks/useScreen';
import TAP_LOGO from '../../common/assets/images/TAPLogo.svg';
import { DELEGATEPROFILE, NUMBER_ARRAY, SELFPROFILE, SETDELEGATE, USER_PROFILE_LABELS } from 'common/global/constants';
import { GenericPopUpUserProfile } from 'TAP/components/UserGroupProfile/GenericPopUpUserProfile';
import { DelegatePopUp } from 'TAP/components/DelegatePopup';
import { clearUserMenuSelection, userMenuSelectedAction } from 'common/redux/actions/appActions';
import { useDispatch, useSelector } from 'react-redux';
import { DelegateDelete, DelegateSwitch, DelegateUserSave, DelegateUserView } from 'TAP/redux/actions/delegateUserAction';
import { TapGlobalMessages } from 'TAP/global';
import { Toaster } from 'TAP/components/Toaster';
import { DeletePopup } from 'TAP/components/DeletePopup';
import { UserDetails } from 'TAP/redux/actions';
import { isLocalStorageKeyExistDefined } from 'TAP/utils/commonMethods';

export const HomeRootLayoutView = () => {
  let redtheme = RedTheme;
  const screen = useScreen();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userDetails = localStorage.getItem('userDetails');

  const userMenuSelected = useSelector((state) => state?.commonRd?.selectedMenu);
  const [selectedUserMenuVal, setSelectedUserMenuVal] = useState('');
  const [isShowDelegatePopUp, setIsShowDelegatePopUp] = useState(false)
  const [saveDelegatePayloadObj, setSaveDelegatePayLoadObj] = useState(null);
  const [isDelegateRequiredFieldValidation, setIsDelegateRequiredFieldValidation] = useState(false);
  const [isShowValidationMsg, setIsShowValidationMsg] = useState(false);
  const [isDelegateEditMode, setIsDelegateEditMode] = useState(false);
  const [isDelegateViewMode, setIsDelegateViewMode] = useState(false);
  const [isSaveDisable, setSaveDisable] = useState(false);
  const [openDeleteConfirmPopup, setOpenDeleteConfirmPopup] = useState(false);
  const [openSwitchDelegateConfirmPopup, setOpenSwitchDelegateConfirmPopup] = useState(false);
  const [switchDelegateType, setSwitchDelegateType] = useState('');
  const [delegateName, setDelegateName] = useState('');
  const [isShowDelegateDeleteMsg, setIsShowDelegateDeleteMsg] = useState(false);
  const [delegateDeleteSuccessMsg, setDelegateDeleteSuccessMsg] = useState('');
  const [exisitngDelegateValidation, setExisitngDelegateValidation] = useState(false);

  
  const isLoadingSavedDelegate = useSelector((state) => state?.delegateUserRd?.isLoadingSavedDelegate);
  const isLoadingDelegateDelete = useSelector((state) => state?.delegateUserRd?.isLoadingDelegateDelete);
  const isLoadingDelegateSwitch = useSelector((state) => state?.delegateUserRd?.isLoadingDelegateSwitchRes);
  const savedDelegateRes = useSelector((state) => state?.delegateUserRd?.savedDelegateRes);
  const delegateUserView = useSelector((state) => state?.delegateUserRd?.delegateUserView);   
  const delegateDeleteRes = useSelector((state) => state?.delegateUserRd?.delegateDeleteRes);
  const delegateSwitchRes = useSelector((state) => state?.delegateUserRd?.delegateSwitchRes);
  const getDelegateSwicthUserDetails = useSelector((state) => state.tapUserDetailsRd); 
  const [reloadKey, setReloadKey] = useState(0);

  const refreshCurrentRoute = () => {
    setReloadKey((k) => `refresh_route${k + 1}`);
  };

  const getLoggedInUser = () => {
    let logInUserDetails;
    if (userDetails && Object.keys(userDetails).length) {
      logInUserDetails = JSON.parse(userDetails);
    }
    return logInUserDetails;
  }

  const handleRefreshNavState = () => {
      const preRoutePath = '/TAP'
        switch (window.location.pathname) {
          case '/TAP/':
            refreshCurrentRoute();
            navigate(`${preRoutePath}/`, {replace: true});
            break;
          case '/TAP/myorganisation':
            refreshCurrentRoute();
            navigate(`${preRoutePath}/myorganisation`, {replace: true});
            break;
          case '/TAP/trainingview':
            refreshCurrentRoute();
            navigate(`${preRoutePath}/trainingview`, {replace: true});
            break;
          case '/TAP/curriculumAssignmentRequest':
            refreshCurrentRoute();
            navigate(`${preRoutePath}/curriculumAssignmentRequest`, {replace: true});
            break;
          default:
            navigate(preRoutePath);
            break;
        }
    };

  /**create switch delegate payload */
  const createSwitchDelegatePayload = () => {
    const loggedInUser = getLoggedInUser();
    const payloadObj = {
      "loggedInUserId": loggedInUser?.user_id,
      "loggedInUserEmail": loggedInUser?.user_email,
      "type": switchDelegateType
    }
    if (switchDelegateType === 'delegate') {
      payloadObj.delegateManagerId = loggedInUser?.delegate_manager_userid;
      payloadObj.delegateManagerEmail = loggedInUser?.delegate_manager_emailid;
    } else if (switchDelegateType === 'self') {
      payloadObj.loggedInUserId = '';
      payloadObj.loggedInUserEmail = UserDetail().userEmailId
    }
    return payloadObj;
  }
  
  const handleDelegatePopupClose = (_event) => {
    setExisitngDelegateValidation(false);
    setIsDelegateRequiredFieldValidation(false);
    setIsShowValidationMsg(false);
    if (isDelegateViewMode) {
      setIsDelegateViewMode(false);
    } else {
      dispatch(userMenuSelectedAction(''));
    }
    if(_event.target.textContent !== USER_PROFILE_LABELS.leftButtonTextEdit) {
      setIsShowDelegatePopUp(false);
      setSelectedUserMenuVal('');
    }
  }

  const handleDelegateDelete = () => {
      const delegateDeletePayload = {
        "id": delegateUserView[NUMBER_ARRAY.zero]?.Id || '',
        "loggedInUserId": delegateUserView[NUMBER_ARRAY.zero]?.manager_id || '',
        "loggedInUserEmail": delegateUserView[NUMBER_ARRAY.zero]?.manager_email || ''
      }
      dispatch(DelegateDelete(delegateDeletePayload));
  }
  /**handle switch toogle */
  const handleDelegateSwitch = () => {
    // logic here
    const switchDelegatePayload = createSwitchDelegatePayload();
    dispatch(DelegateSwitch(switchDelegatePayload));
  }

  const handlePopUpSave = (_event) => {
    // logic here
    /**Delete Delegate and return*/
    if(_event.target.textContent === USER_PROFILE_LABELS.rightButtonTextDelete){
      setOpenDeleteConfirmPopup(true)
      setDelegateName(delegateUserView[NUMBER_ARRAY.zero]?.user_full_name || '')
      return;
    }
    if (isDelegateRequiredFieldValidation){
      setExisitngDelegateValidation(false);
      setIsShowValidationMsg(true);
    } else {
      dispatch(DelegateUserSave(saveDelegatePayloadObj));
      setIsShowValidationMsg(false);
    }
  }

  const handleSavePayload = (payload, isSaveDisabled, reuiredFieldValidation) => {
    // logic here 
    if (reuiredFieldValidation && !isSaveDisabled) { 
      setIsDelegateRequiredFieldValidation(reuiredFieldValidation)
      setSaveDisable(false);
      return 
    } else {
      setIsDelegateRequiredFieldValidation(false);
    }    
    setSaveDisable(isSaveDisabled);
    setSaveDelegatePayLoadObj(payload);
  }

  const viewDelegateApiDispatch = () => {
    let delegateObj = undefined;
    if (isLocalStorageKeyExistDefined('delegateProfileSwitched') && localStorage.getItem('delegateProfileSwitched') !== '[object Object]') {
      delegateObj = JSON.parse(localStorage.getItem('delegateProfileSwitched'));
    }
    const loggedInUser = getLoggedInUser();
    let payload = {
      "loggedInUserId": loggedInUser?.user_id,
      "loggedInUserEmail": loggedInUser?.user_email
    };
    if (delegateObj && delegateObj.isDelegateSwitch) {
      payload.loggedInUserId = '';
      payload.loggedInUserEmail = UserDetail().userEmailId
    }
    dispatch(DelegateUserView(payload));
  }

  useEffect(() => {
    if(userMenuSelected && userMenuSelected !== '') {
      setSelectedUserMenuVal(userMenuSelected);
      setIsDelegateViewMode(false);
      if (userMenuSelected === SETDELEGATE){
        viewDelegateApiDispatch();
      }
      dispatch(clearUserMenuSelection());
    }
  }, [userMenuSelected])

  useEffect(() => {
    if (selectedUserMenuVal !== '') {
      switch (selectedUserMenuVal) {
        case DELEGATEPROFILE:
          setOpenSwitchDelegateConfirmPopup(true);
          setSwitchDelegateType('delegate');
          break;
        case SELFPROFILE:
          setOpenSwitchDelegateConfirmPopup(true);
          setSwitchDelegateType('self');
          break;
        case SETDELEGATE:
          setIsShowDelegatePopUp(true);
          break;

        default:
          break;
      }
    }
  }, [selectedUserMenuVal])

  useEffect(() => {
    if (delegateUserView !== undefined && delegateUserView !== null && isDelegateViewMode) {
      setIsDelegateEditMode(true);
    } else {
      setIsDelegateEditMode(false);
    }
  }, [delegateUserView, isDelegateViewMode])

  useEffect(() => {
    if(delegateUserView.length === NUMBER_ARRAY.one){
      setIsDelegateViewMode(true);
      setIsDelegateRequiredFieldValidation(false);
      setExisitngDelegateValidation(false);
    }
  }, [delegateUserView])

  useEffect(() => {
    if (!isLoadingSavedDelegate && savedDelegateRes === "Data Saved successfully!") {
      setIsDelegateViewMode(true);
      viewDelegateApiDispatch(); 
    } else if (!isLoadingSavedDelegate && savedDelegateRes === TapGlobalMessages.exisitngDelegateMsg) {
      setIsShowValidationMsg(true);
      setExisitngDelegateValidation(true)
    } else {
      setIsDelegateViewMode(false);
    }
  }, [isLoadingSavedDelegate, savedDelegateRes])

  useEffect(() => {
    const loggedInUser = getLoggedInUser();
    if(!isLoadingDelegateSwitch && delegateSwitchRes && Object.hasOwn(delegateSwitchRes,'isDelegateSwitch')){
      const profilePayload = {email: delegateSwitchRes?.isDelegateSwitch ? loggedInUser?.delegate_manager_emailid 
        : UserDetail().userEmailId};
      const delegateObj = {isDelegateSwitch: delegateSwitchRes?.isDelegateSwitch || false, 
        email: profilePayload?.email, message: delegateSwitchRes?.Message || '', IsManagerEnable: delegateSwitchRes?.IsManagerEnable || ''}
      localStorage.setItem('delegateProfileSwitched', JSON.stringify(delegateObj));
      dispatch(UserDetails(profilePayload));
    }
  }, [isLoadingDelegateSwitch, delegateSwitchRes])

  useEffect(() => {
    if (getDelegateSwicthUserDetails && delegateSwitchRes && Object.hasOwn(delegateSwitchRes,'isDelegateSwitch')) {
       handleRefreshNavState();
    }
  }, [getDelegateSwicthUserDetails])

  useEffect(() => {
    if(isLoadingDelegateDelete && delegateDeleteRes == "Deleted successfully!"){
      setOpenDeleteConfirmPopup(false);
      setSelectedUserMenuVal('');
      setIsShowDelegatePopUp(false);
      setIsShowDelegateDeleteMsg(true);
      setDelegateDeleteSuccessMsg(delegateDeleteRes);
    }

  }, [delegateDeleteRes, isLoadingDelegateDelete])

  return (
    <>
      <Fragment>
        <Toaster
          onClose={() => setIsShowDelegateDeleteMsg(false)}
          hideDuration={NUMBER_ARRAY.fiveThousand}
          severity={'success'}
          show={isShowDelegateDeleteMsg}
          message={delegateDeleteSuccessMsg}
        />
        {/* this is Switch Delegate popup same as delete confirm pop up */}
        <DeletePopup
          popupHeader={`Are you sure you want to switch to ${switchDelegateType}?`}
          SubHeader={`You will redirected to the 'My Performance' page of ${switchDelegateType}.`}
          leftBtnText='No'
          rightBtnText='Yes'
          open={openSwitchDelegateConfirmPopup}
          deleteFilterName={delegateName}
          handleFavDelete={handleDelegateSwitch}
          handleClose={() => {
            setOpenSwitchDelegateConfirmPopup(false),
            setSelectedUserMenuVal('')
          }}
        />
        {/* this is Switch Delegate popup same as delete confirm pop up */}
        <DeletePopup
          popupHeader='Are you sure you want to delete the "delegate"?'
          SubHeader="This item will be deleted permanently. You can't undo this action."
          leftBtnText='Cancel'
          rightBtnText='Ok'
          open={openDeleteConfirmPopup}
          deleteFilterName={delegateName}
          handleFavDelete={handleDelegateDelete}
          handleClose={() => setOpenDeleteConfirmPopup(false)}
        />
        <GenericPopUpUserProfile
          open={isShowDelegatePopUp}
          onClose={handleDelegatePopupClose}
          onConfirm={handlePopUpSave}
          title={isDelegateViewMode ? `Delegate Details` : isDelegateEditMode 
            && !isDelegateViewMode ? `Edit Delegate` : `Set Delegate`}
          disableSaveButton={isSaveDisable}
          cssOverFlowProp='visible'
          rightButtonText={isDelegateViewMode ? USER_PROFILE_LABELS.rightButtonTextDelete : USER_PROFILE_LABELS.rightButtonText}
          leftButtonText={isDelegateViewMode ? USER_PROFILE_LABELS.leftButtonTextEdit : USER_PROFILE_LABELS.leftButtonText}
        > 
          <Fragment>
            <Stack className='pop-up-user-profile'>
              {isShowValidationMsg &&
                (
                  <Grid container>
                    <Grid item md={12} className='other-warning-toaster'>
                      <Toaster
                        onClose={() => setIsShowValidationMsg(false)}
                        vertical={'bottom'}
                        hideDuration={NUMBER_ARRAY.thirtyThousand}
                        severity={'warn'}
                        show={isShowValidationMsg}
                        message={exisitngDelegateValidation ? TapGlobalMessages.exisitngDelegateMsg 
                          : TapGlobalMessages.userGroupProfile.reuiredFieldValidationMessage}
                      />
                    </Grid>
                  </Grid>
                )
              }
            </Stack>
            <DelegatePopUp saveCallBack={handleSavePayload} isViewMode={isDelegateViewMode}
              logInUserDetails={getLoggedInUser()} isEditMode = {isDelegateEditMode}/>
          </Fragment>
        </GenericPopUpUserProfile>
      </Fragment>
      <Box component='main' sx={{ flex: '1 0 auto' }}>
        {/** 12 Colum Grid defined for base layout */}
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(12, 1fr)',
            gap: 1,
            gridTemplateRows: 'auto',
            gridTemplateAreas: `"main main main main main main main main main main main main"`,
          }}
        >
          <Box
            className='tap-page-layout'
            sx={{ gridArea: 'main', background: redtheme.palette.box.light_grayish_orange }}
          >
            {/** Header */}
            {screen.isMobile ? (
              <MobileHeader showNavigation logo={<img src={TAP_LOGO} height='40' width='47' />} />
            ) : (
              <Header />
            )}
            <Box
              className='tap-content-area'
              sx={{
                width: '100%',
              }}
            >
              {/** ContentArea loads dynamic routes pages */}
              <Box
                className='dashboard'
                sx={{
                  p: screen.resolveStyles({
                    mobile: NUMBER_ARRAY.zero,
                    tablet: '12px 0 0 0',
                    desktop: '22px 0 0 0',
                  }),
                }}
              >
                <Outlet  key={reloadKey}/>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      {/** Footer */}
      <Box component='footer' sx={{ flexShrink: 0 }}>
        <Footer></Footer>
      </Box>
    </>
  );
};
